import { createContext, useContext } from 'react'
import type { Edge, Node } from '@xyflow/react'

export interface AutomationEditorContextValue {
  nodes: Node[]
  edges: Edge[]
  connectingNodeId: string | null
  startConnecting: (nodeId: string) => void
  cancelConnecting: () => void
  connectNodes: (fromId: string, toId: string) => void
  disconnectEdge: (edgeId: string) => void
  disconnectBetween: (nodeA: string, nodeB: string) => void
  removeNode: (nodeId: string) => void
}

export const AutomationEditorContext = createContext<AutomationEditorContextValue | null>(null)

export function useAutomationEditor(): AutomationEditorContextValue {
  const ctx = useContext(AutomationEditorContext)
  if (!ctx) {
    return {
      nodes: [],
      edges: [],
      connectingNodeId: null,
      startConnecting: () => {},
      cancelConnecting: () => {},
      connectNodes: () => {},
      disconnectEdge: () => {},
      disconnectBetween: () => {},
      removeNode: () => {},
    }
  }
  return ctx
}
